package er.prateek.crossly.persistence

/**
 * The daily reveal-letter counter. Persisted for the same reason as
 * [AdFrequencyState.rewardedToday]: "not more than N today" is exactly the cap a relaunch
 * would otherwise reset.
 */
data class RevealFrequencyState(
    /** ISO date the counter below belongs to; a different date resets it. */
    val dayKey: String = "",
    val revealsToday: Int = 0,
)

interface RevealPrefsStore {
    fun load(): RevealFrequencyState
    fun save(state: RevealFrequencyState)
}
